import React from "react";
import LayoutClients from "../../components/layout-clients";
import SofomForgotPasswordForm from "../../components/afisofom/forgot-password-form";
import {useChangeTitleFavicon} from "../../hooks/useChangeTitle";
import Strings from "../../assets/strings";

const AfisofomForgotPassword = ({ history }) => {
    useChangeTitleFavicon(Strings.TITLE_FORGOT_PASSWORD, "afisofom");
    return (
        <LayoutClients history={history} site="sofom">
            <div className="container">
                <SofomForgotPasswordForm
                    onRecover={email =>
                        history.push('/afisofom/restaurar-contrasena?email=' + email)
                    }
                />
            </div>
        </LayoutClients>
    );
}

export default AfisofomForgotPassword;
